export default __webpack_public_path__ + "static/media/property_767.42130bc5.png";